import React from "react";
import "./Home.css";

export default function Home() {
  return (
    <section className="hero">
      <div className="hero-avatar" />
      <h1 className="hero-title">Haotlas123</h1>
      {/* 可以以后再填简介 */}
      {/* <p className="hero-subtitle">一句话介绍</p> */}
    </section>
  );
}
